import React, { useMemo, useState } from "react";

const topics = [
  "Selenium WebDriver",
  "Playwright",
  "Cypress",
  "REST API Testing",
  "Postman Collections",
  "TestNG",
  "JUnit",
  "Locator Strategies",
  "Page Object Model",
  "Regression Suite",
  "Smoke Testing",
  "CI/CD Pipelines",
];

export default function AutoComplete() {
  const [query, setQuery] = useState("");
  const [selectedTopics, setSelectedTopics] = useState(["Playwright"]);

  const suggestions = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return topics.filter((topic) => !selectedTopics.includes(topic)).slice(0, 6);
    }

    return topics
      .filter((topic) => !selectedTopics.includes(topic))
      .filter((topic) => topic.toLowerCase().includes(normalizedQuery))
      .slice(0, 6);
  }, [query, selectedTopics]);

  const addTopic = (topic) => {
    setSelectedTopics((current) => [...current, topic]);
    setQuery("");
  };

  const removeTopic = (topic) => {
    setSelectedTopics((current) => current.filter((item) => item !== topic));
  };

  return (
    <div className="practice-demo-card">
      <h3>Auto Complete</h3>
      <p>
        Type a QA topic to see smart suggestions, then select it to build a practice
        plan. This demo is useful for testing keyboard flows, filtering, and chip-style
        multi-select behavior.
      </p>

      <div className="practice-demo-grid">
        <div className="demo-panel">
          <h4>Multi-select Topics</h4>
          <p>Search and add the topics you want to include in your learning sprint.</p>

          <div className="autocomplete-shell">
            <input
              type="text"
              className="autocomplete-input"
              placeholder="Start typing a topic like Selenium or API..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />

            {suggestions.length > 0 && (
              <ul className="autocomplete-list">
                {suggestions.map((topic) => (
                  <li key={topic}>
                    <button type="button" onClick={() => addTopic(topic)}>
                      {topic}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="autocomplete-tags">
            {selectedTopics.map((topic) => (
              <span key={topic} className="autocomplete-tag">
                {topic}
                <button type="button" aria-label={`Remove ${topic}`} onClick={() => removeTopic(topic)}>
                  x
                </button>
              </span>
            ))}
          </div>
        </div>

        <div className="demo-panel">
          <h4>Test Ideas</h4>
          <p>
            Validate filtering, duplicate prevention, keyboard support, chip removal,
            and empty-state behavior for a realistic widget.
          </p>
          <div className="autocomplete-helper">
            Suggested checks: partial match search, case-insensitive results, tag removal,
            and ensuring selected values are not suggested again.
          </div>
        </div>
      </div>
    </div>
  );
}
